export default __webpack_public_path__ + "static/media/login_app.af24ca6f.PNG";